'use client'

import { cn } from '@nwwp/ui-shadcn'

/**
 * One ranked row with ▲▼ reorder and remove. Keyboard / screen-reader path for ordering.
 */
export function OrderedTile({
  rank,
  title,
  subtitle,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onRemove,
  removeLabel,
}: {
  rank: number
  title: string
  subtitle?: string
  isFirst: boolean
  isLast: boolean
  onMoveUp: () => void
  onMoveDown: () => void
  onRemove: () => void
  removeLabel: string
}) {
  return (
    <li className="flex items-start gap-3 rounded-xl bg-card p-3 shadow-sm">
      <span
        aria-hidden="true"
        className={cn(
          'mt-0.5 flex size-6 shrink-0 items-center justify-center rounded-full text-body-xs font-bold tabular-nums',
          rank === 1 ? 'bg-green-lighter-2 text-black' : 'bg-bone-warm text-neutral-darker'
        )}
      >
        {rank}
      </span>

      <span className="flex-1">
        <span className="block text-body-sm-bold text-gray-darker">{title}</span>
        {subtitle && <span className="block text-body-xs text-neutral-darker">{subtitle}</span>}
      </span>

      <span className="flex shrink-0 items-center gap-1">
        <button
          type="button"
          onClick={onMoveUp}
          disabled={isFirst}
          aria-label={`Move ${title} up`}
          className="flex size-7 items-center justify-center rounded-full text-neutral-darker hover:bg-bone-warm disabled:opacity-30"
        >
          <span aria-hidden="true">▲</span>
        </button>
        <button
          type="button"
          onClick={onMoveDown}
          disabled={isLast}
          aria-label={`Move ${title} down`}
          className="flex size-7 items-center justify-center rounded-full text-neutral-darker hover:bg-bone-warm disabled:opacity-30"
        >
          <span aria-hidden="true">▼</span>
        </button>
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel}
          className="flex size-7 items-center justify-center rounded-full text-neutral-darker hover:bg-bone-warm"
        >
          <span aria-hidden="true">×</span>
        </button>
      </span>
    </li>
  )
}
